var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_log") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.4,27.6H2.5V4.5H29.4Zm-25.9-1H28.4V5.5H3.5Z",
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5.5,
    width: 26.9,
    height: 1.9,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.333,
    y: 9.5,
    width: 8.167,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.333,
    y: 12.083,
    width: 12.5,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.333,
    y: 14.75,
    width: 10.617,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.333,
    y: 17.583,
    width: 14.167,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.333,
    y: 20.5,
    width: 9.834,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 23.083,
    width: 12.167,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 9.5,
    width: 4.333,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 12.083,
    width: 4.333,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 12.083,
    width: 4.333,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 14.667,
    width: 4.333,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 17.25,
    width: 4.333,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 20.5,
    width: 4.333,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 23.083,
    width: 4.333,
    height: 1,
    style: {
      fill: "#00bd02"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.5f3ff6b17a1c7ef9f88b5997914efaa7.svg";
export { ForwardRef as ReactComponent };